/*
  CUSTOM ADDITION — added 12.10.2026 by OH
  Purpose: Scales the main menu font size down on mobile/tablet (<1000px) so that
  the widest menu item always fits the menu width. Sets --menu-fit-font-size on the
  menu linklist, which is used in theme.css. Desktop keeps the regular MUBI H1 size.
*/
(function () {
  var MIN_FONT_SIZE = 20; // px, lower limit for very long menu items
  var SAFETY = 0.98;      // small buffer against rounding
  var mobileQuery = window.matchMedia('(max-width: 999px)');
  var lastWidth = null;

  function getElements() {
    return {
      list: document.querySelector('#sidebar-menu .header-sidebar__linklist'),
      scroller: document.querySelector('#sidebar-menu .header-sidebar__scroller')
    };
  }

  // Natural width of one menu item (text + counter), measured without line breaks
  function measureItem(button) {
    var target = button.querySelector('.menu-collection-link');
    if (target) {
      target.style.whiteSpace = 'nowrap';
      var width = target.getBoundingClientRect().width;
      target.style.whiteSpace = '';
      return width;
    }
    var range = document.createRange();
    range.selectNodeContents(button);
    return range.getBoundingClientRect().width;
  }

  function fitMenu() {
    var els = getElements();
    if (!els.list || !els.scroller) return;

    // Always measure at the regular size first
    els.list.style.removeProperty('--menu-fit-font-size');
    if (!mobileQuery.matches) return;

    var scrollerStyle = getComputedStyle(els.scroller);
    var available = els.scroller.clientWidth
      - (parseFloat(scrollerStyle.paddingInlineStart) || 0)
      - (parseFloat(scrollerStyle.paddingInlineEnd) || 0);
    if (available <= 0) return; // menu closed or not rendered yet

    var buttons = els.list.querySelectorAll(':scope > li .header-sidebar__linklist-button');
    if (!buttons.length) return;

    var baseSize = parseFloat(getComputedStyle(buttons[0]).fontSize);
    var widest = 0;
    buttons.forEach(function (button) {
      widest = Math.max(widest, measureItem(button));
    });
    if (widest <= available) return; // everything fits, keep MUBI H1

    var fitted = Math.max(MIN_FONT_SIZE, Math.floor(baseSize * (available / widest) * SAFETY));
    els.list.style.setProperty('--menu-fit-font-size', fitted + 'px');
  }

  function init() {
    var els = getElements();
    if (!els.scroller) return;

    // Runs when the menu opens and whenever its width changes
    var observer = new ResizeObserver(function (entries) {
      var width = entries[0].contentRect.width;
      if (width === lastWidth) return;
      lastWidth = width;
      fitMenu();
    });
    observer.observe(els.scroller);

    mobileQuery.addEventListener('change', fitMenu);

    // Measure again once the web fonts are loaded
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitMenu);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();